import { Component } from "@angular/core";
import { SharedService } from "src/app/services/shared.service";

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
  toastType: string = '';
  msg: string = "";
  isEnabled: boolean = false;
  fireCloseAnimation: boolean = false;
  startImediate: boolean = false;

  constructor(private sharedService: SharedService) {
    this.enableListener();
  }

  enableLoader(startImediate: boolean, topLayer: boolean) {
    if (typeof window !== "undefined") {
      this.startImediate = startImediate;
      this.isEnabled = true;

      if(topLayer){
        setTimeout(() => {
          const toast: any = document.getElementById('toast');
          if(toast) {
            toast.setAttribute("popover", "auto");
            // popover
            toast.classList.add('popover-top-layer');
            // console.log(toast);
            toast.showPopover();
          }
        });
      }


      // document.body.style.overflow = `hidden`;
      setTimeout(() => {
        this.disableLoader();
      }, 5000);
    }
  }

  disableLoader() {
    if (typeof window !== "undefined") {
      this.fireCloseAnimation = true;
      setTimeout(() => {
      this.isEnabled = false;
      this.fireCloseAnimation = false;
      // document.body.style.overflow = `scroll`;
      }, 300);
    }
  }

  enableListener() {
    let _this = this;
    let firstFire: boolean = true; //to ignore first time, the reason behind that is the initialization of the variable will cause this
    this.sharedService.toastFlag$.subscribe((flag: any) => {
      this.msg = flag.msg;
      this.toastType = flag.toastType;
      if (!firstFire) {
        const globalFlag = !!flag.value;
        globalFlag
          ? _this.enableLoader(flag.startImediate, flag.topLayer)
          : _this.disableLoader();
      } else {
        firstFire = false;
      }
    });
  }
}
